import React from "react";

import { Button, Col, Row } from "react-bootstrap";

import { ButtonsContainer } from "../../IncidentReportForm";

import YesOrNo from "app/_pages/_healthSafetyEnvironment/YesOrNo.component";
import { SearchableSelect } from "app/Components/SearchableSelect/SSingleSelect";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

function VehicleDetailsTab({
  form = {},
  onChange,
  error = {},
  setTab,
  onSubmit,
  vehicleDetails,
  vehicleDetailsErrors,
  onChangeVehicleDetails,
  deleteRowVehicleDetails,
  addRowVehicleDetails,
}) {
  return (
    <div className="card p-3 pb-0 mt-3">
      <div className="simple-card-title">
        <h3 class="text-capitalize mb-0">Vehicle Details</h3>
      </div>
      <div className="ehsFormWrapper">
        <Row className="mb-4 justify-content-start align-items-center">
          <Col lg={4}>
            <YesOrNo
              title="Vehicles Involved"
              name="isVehicleIncident"
              value={form.isVehicleIncident === null ? false : form.isVehicleIncident}
              onChange={onChange}
            />
            <span className="small text-danger">{error?.isVehicleIncident}</span>
          </Col>
        </Row>
        {form.isVehicleIncident && (
          <div className="w-100">
            <div className="table-responsive drillingPlan-plannedEdit">
              <table className="table table-bordered mb-3">
                <thead>
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Vehicle No.</th>
                    <th scope="col">Vehicle Type</th>
                    <th scope="col">Vehicle Owner</th>
                    <th scope="col">Driver Name</th>
                    <th scope="col">Observation</th>
                    <th scope="col" style={{ minWidth: "150px" }}>
                      Insurance Status
                    </th>
                    <th scope="col">Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {vehicleDetails.length ? (
                    vehicleDetails.map((x, index) => {
                      return x.deleted ? null : (
                        <tr key={index}>
                          <th>{index + 1}</th>
                          <td>
                            <input
                              value={x.number}
                              onChange={({ target: { name, value } }) =>
                                onChangeVehicleDetails(index, name, value)
                              }
                              name="number"
                              type="text"
                              className="form-control"
                            />
                            <span className="small text-danger">
                              {vehicleDetailsErrors[index]?.number}
                            </span>
                          </td>
                          <td>
                            <SearchableSelect
                              value={x.type}
                              onChange={({ target: { name, value } }) =>
                                onChangeVehicleDetails(index, name, value)
                              }
                              name="type"
                              // className="form-control"
                              options={["LMV", "Buyers Truck", "Dumper", "Disel Tanker", "Troller", "Crane", "Tractor", "Two-wheeler", "Truck", "Explosive Van"]}
                              init="none"
                              array="single"
                            ></SearchableSelect>
                            <span className="small text-danger">
                              {vehicleDetailsErrors[index]?.type}
                            </span>
                          </td>
                          <td>
                            <SearchableSelect
                              value={x.owner}
                              onChange={({ target: { name, value } }) =>
                                onChangeVehicleDetails(index, name, value)
                              }
                              name="owner"
                              // className="form-control"
                              options={["Company", "Contractor", "Others"]}
                              init="none"
                              array="single"
                            ></SearchableSelect>
                          </td>
                          <td>
                            <input
                              value={x.driverName}
                              onChange={({ target: { name, value } }) =>
                                onChangeVehicleDetails(index, name, value)
                              }
                              name="driverName"
                              type="text"
                              className="form-control"
                            />
                            <span className="small text-danger">
                              {vehicleDetailsErrors[index]?.driverName}
                            </span>
                          </td>
                          <td>
                            <input
                              value={x.observation}
                              onChange={({ target: { name, value } }) =>
                                onChangeVehicleDetails(index, name, value)
                              }
                              name="observation"
                              type="text"
                              className="form-control"
                            />
                            <span className="small text-danger">
                              {vehicleDetailsErrors[index]?.observation}
                            </span>
                          </td>
                          <td>
                            <SearchableSelect
                              value={x.insuranceStatus}
                              onChange={({ target: { name, value } }) =>
                                onChangeVehicleDetails(index, name, value)
                              }
                              name="insuranceStatus"
                              // className="form-control"
                              options={[
                                "Comprehensive",
                                "Third Party only",
                                "Not Known",
                                "No Insurance",
                              ]}
                              init="none"
                              array="single"
                            ></SearchableSelect>
                          </td>
                          <td>
                            <div className="actionIconsGroup">
                              {/* <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top">Delete</Tooltip>
                                }
                              >
                                <a
                                  href
                                  className="icons text-danger pointer font-20"
                                  onClick={() => deleteRowVehicleDetails(index)}
                                >
                                  <FiMinusCircle />
                                </a>
                              </OverlayTrigger> */}
                              <CustomTooltip tooltip="Delete">
                                <a
                                  href
                                  className="icons text-danger pointer font-20"
                                  onClick={() => deleteRowVehicleDetails(index)}
                                >
                                  <FiMinusCircle />
                                </a>
                              </CustomTooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" align="center">
                        {/* <div className="alert alert-danger d-inline-block m-0">
                                                      <strong>Empty</strong>
                                                  </div> */}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan="10">
                      {/* <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                      >
                        <Button
                          className="addRowPluseIcon"
                          onClick={addRowVehicleDetails}
                        >
                          <FiPlusCircle />
                        </Button>
                      </OverlayTrigger> */}
                      <CustomTooltip tooltip="Add Row">
                        <Button
                          className="addRowPluseIcon"
                          onClick={addRowVehicleDetails}
                        >
                          <FiPlusCircle />
                        </Button>
                      </CustomTooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <ButtonsContainer
        incidentStatus={form.incidentStatus}
        setTab={setTab}
        prev={4}
        closeIncident={form.closeIncident}
        next={6}
        onSubmit={onSubmit}
      />
    </div>
  );
}

export default VehicleDetailsTab;
